import type { PayloadAction } from '@reduxjs/toolkit';
import { createAppSlice } from '@slices/createAppSlice';
import type { TrackingSource } from '@helpers/analyticsHelpers/trackDeliveryPicker';

interface DeliveryPickerState {
  isOpen: boolean;
  proceedToCheckout: boolean;
  trackingSource?: TrackingSource;
}

const initialState: DeliveryPickerState = {
  isOpen: false,
  trackingSource: undefined,
  proceedToCheckout: false,
};

export const deliveryPickerSlice = createAppSlice({
  name: 'deliveryPicker',
  initialState,
  reducers: (create) => ({
    openDeliveryPicker: create.reducer(
      (
        state,
        action: PayloadAction<{
          proceedToCheckout?: boolean;
          trackingSource: TrackingSource;
        }>
      ) => {
        state.isOpen = true;
        state.trackingSource = action.payload.trackingSource;
        state.proceedToCheckout = action.payload.proceedToCheckout || false;
      }
    ),
    closeDeliveryPicker: create.reducer((state, action: PayloadAction<{ proceedToCheckout?: boolean } | undefined>) => {
      state.isOpen = false;
      state.trackingSource = undefined;
      state.proceedToCheckout = action.payload?.proceedToCheckout || false;
    }),
  }),
  selectors: {
    selectDeliveryPicker: (deliveryPicker) => deliveryPicker,
    selectDeliveryPickerProceedToCheckout: (deliveryPicker) => deliveryPicker.proceedToCheckout,
    selectDeliveryPickerTrackingSource: (deliveryPicker) => deliveryPicker.trackingSource,
  },
});

// Actions
export const { openDeliveryPicker, closeDeliveryPicker } = deliveryPickerSlice.actions;

// Selectors
export const { selectDeliveryPicker, selectDeliveryPickerProceedToCheckout, selectDeliveryPickerTrackingSource } =
  deliveryPickerSlice.selectors;
